/* @flow */

export const PATCH_ENTITIES = 'PATCH_ENTITIES';
